import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { FaqComponent } from '../faq/faqComponent';
import { faqItems }     from '../faq/faqInterface';

@Component({
  selector: 'app-faq-section',
  standalone: true,
  imports: [TranslocoModule, FaqComponent],
  templateUrl: './faq-section.html',
  styles: [`:host { display: block; }`],
})
export class FaqSectionComponent {
  faqItems = faqItems;
  expandedIndex: number | null = null;

  onToggle(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }
}
